// extracted by mini-css-extract-plugin
export default {"row":"icon-select_row__PX-rG","input":"icon-select_input__qYTdJ","item":"icon-select_item__Lr3r4","active":"icon-select_active__qhIFI"};